import { show, hide, trigger } from './utility';

/// show-depends-on-select is used when a section need to be hided based on a select element

/// <div data-gs-toggle="show-depends-on-radio" data-gs-target="@Html.NameFor(n=>n.AsperfestBoolRadio)" data-gs-show-value="True"></div>

export default function (targetElem: HTMLElement) {
    let controlElemSelector = targetElem.dataset['gsTarget'];
    let controlElem = document.querySelector(controlElemSelector) as HTMLInputElement;
    if (!controlElem) {
        throw new Error(`Can not find control element: ${controlElem}`);
    }
    controlElem.addEventListener('change', function(event){
        var currValElem = event.target as HTMLInputElement;
        if (currValElem.checked){
            show(targetElem)
        } else {
            hide(targetElem);
        }
    })
    // if none is checked hide it by default
    if (!controlElem.checked){
        hide(targetElem);
    }
}